<template>
        <!-- FEATURES-8
    ============================================= -->
    <section id="features-8" class="pb-20 pt-60 features-section division">
        <div id="howitworks"></div>
        <div class="container">


            <!-- SECTION TITLE -->
            <div class="row justify-content-center">
                <div class="col-lg-10 col-xl-8">
                    <div class="section-title title-01 mb-70">

                        <!-- Title -->
                        <h2 class="h2-md">How it works?</h2>
                        <!-- Text -->
                        <p class="p-xl">Just 3 simple steps to start using Creditfixrr.com.</p>
                        <div class="dtr-styled-divider divider-center bg-light-green mb-2"></div>
                        <a href="https://www.smartcredit.com/?PID=54821" target="_blank" class="dtr-btn-flat btn-green dtr-px-50">
                            Get Credit Report
                        </a>
                    </div>
                </div>
            </div>
        </div>	   <!-- End container -->
    </section>	<!-- END FEATURES-8 -->


    <section id="tabs-2" class="tabs-section division">
        <div class="container">
            <div class="row row-cols-1 row-cols-md-2 d-flex align-items-center">


                <!-- TABS NAVIGATION -->
                <div class="col">
                   <div class="tabs-nav clearfix">
                       <ul class="tabs-1">


                           <!-- TAB-1 LINK -->
                           <li class="tab-link current" data-tab="tab-1">

                               <!-- Title -->
                               <!-- <h5 class="h5-sm">Perfect Integration</h5> -->

                               <!-- Text -->
                               <!-- <p class="p-lg">Semper lacus cursus porta feugiat primis a luctus ultrice tellus potenti
                                  neque dolor in primis
                               </p> -->

                               <div class="cbox mb-40">

                                <!-- Icon -->
                                <div class="cbox-ico">
                                    <div class="ico-65">
                                        <span class="flaticon-double-click"></span>
                                    </div>
                                </div>

                                <!-- Text -->
                                <div class="cbox-txt">
                                    <h5 class="h5-md">Import Your Credit Report</h5>
                                    <p class="p-lg">Simply upload your credit report from IdentityIQ, SmartCredit or MyScoreIQ . Using our 1-Click Credit Report Import system.
                                    </p>
                                </div>

                            </div>

                           </li>

                           <!-- TAB-2 LINK -->
                           <li class="tab-link" data-tab="tab-2">

                               <!-- Title -->
                               <!-- <h5 class="h5-sm">Speed Optimized</h5> -->

                               <!-- Text -->
                               <!-- <p class="p-lg">Semper lacus cursus porta feugiat primis a luctus ultrice tellus potenti
                                  neque dolor in primis
                               </p> -->
                               <div class="cbox mb-40">

                                <!-- Icon -->
                                <div class="cbox-ico">
                                    <div class="ico-65">
                                        <span class="flaticon-increase-1"></span>
                                    </div>
                                </div>

                                <!-- Text -->
                                <div class="cbox-txt">
                                    <h3 class="h5-md">Create A Dispute Letter</h3>
                                    <p class="p-lg">
                                        Select from one of our list dispute letter templates. Then follow the our Dispute Flows
                                    </p>
                                </div>

                            </div>



                            </li>

                           <!-- TAB-3 LINK -->
                           <li class="tab-link" data-tab="tab-3">

                               <!-- Title -->
                               <!-- <h5 class="h5-sm">Advanced Security</h5> -->

                               <!-- Text -->
                               <!-- <p class="p-lg">Semper lacus cursus porta feugiat primis a luctus ultrice tellus potenti
                                  neque dolor in primis
                               </p> -->
                               <!-- CONTENT BOX #3 -->
                                <div class="cbox mb-40">

                                <!-- Icon -->
                                <div class="cbox-ico">
                                    <div class="ico-65">
                                        <span class="flaticon-layers"></span>
                                    </div>
                                </div>

                                <!-- Text -->
                                <div class="cbox-txt">
                                    <h3 class="h5-md">Mail Your Dispute Letter</h3>
                                    <p class="p-lg">
                                        You have the option of sending your Dispute Letters directly from our software via Certified Mail or Fax . You can also Download/Print your dispute letters, then mail them from your local Post Office.
                                    </p>
                                </div>

                            </div>

                           </li>


                       </ul>
                   </div>
                </div>	<!-- END TABS NAVIGATION -->


                <!-- IMAGE BLOCK -->
                <div class="col">
                    <div class="img-block right-column wow fadeInLeft">
                       <div class="tabs-content">

                           <!-- TAB #1 IMAGE -->
                           <div id="tab-1" class="tab-content current">
                               <img class="img-fluid" src="/landing/images/img-05.png" alt="tab-image" />
                           </div>

                           <!-- TAB #2 IMAGE -->
                           <div id="tab-2" class="tab-content">
                               <img class="img-fluid" src="/landing/images/img-10.png" alt="tab-preview">
                           </div>

                          <!-- TAB #3 IMAGE -->
                          <div id="tab-3" class="tab-content">
                               <img class="img-fluid" src="/landing/images/img-08.png" alt="tab-image" />
                          </div>


                       </div>
                   </div>
                </div>	<!-- END IMAGE BLOCK -->


            </div>	   <!-- End row -->
        </div>	    <!-- End container -->
   </section>	 <!-- END TABS-2 -->
</template>
